import React from 'react';
import Img from 'gatsby-image';
import { HeaderStoryblok } from '../../../_shared/interfaces/storyblok';
// @ts-ignore (no types available for 'gatsby-storyblok-image')
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import StoryblokButton from '../hs-button/storyblok-button';

import * as HeaderStyles from './header.module.scss';

const Header = ({ blok, storyblokCommon }: { blok: HeaderStoryblok; storyblokCommon: StoryblokCommon }) => {
    const [images, setImages] = React.useState<any[]>([]);

    React.useEffect(() => {
        const imageList = [];
        if (blok.background_mobile && blok.background_mobile.filename) {
            imageList.push({ ...getFluidGatsbyImage(blok.background_mobile.filename), media: '(max-width: 767px)' });
        }
        if (blok.background_desktop && blok.background_desktop.filename) {
            imageList.push({ ...getFluidGatsbyImage(blok.background_desktop.filename), media: '(min-width: 768px)' });
        }
        setImages(imageList);
    }, [blok]);

    return (
        <div className={HeaderStyles.header} style={{ backgroundColor: blok.background_color?.color ?? '' }}>
            {images.length > 0 && (
                <div className={HeaderStyles.imageWrapper}>
                    <Img fluid={images} alt={blok.background_desktop?.alt ?? ''} />

                    {blok.background_cover !== 'none' && (
                        <div className={[HeaderStyles.cover, HeaderStyles[blok.background_cover ?? '']].join(' ')} />
                    )}
                </div>
            )}

            {storyblokCommon.configuration.content.theme === 'hs' && blok.image_slope && <div className={HeaderStyles.slope} />}

            <div className={[HeaderStyles.inner, images.length ? HeaderStyles.innerWithImage : ''].join(' ')}>
                <div
                    style={{
                        paddingTop: (blok.padding_top ?? '0') + '%',
                        paddingRight: (blok.padding_right ?? '0') + '%',
                        paddingBottom: (blok.padding_bottom ?? '0') + '%',
                        paddingLeft: (blok.padding_left ?? '0') + '%',
                    }}
                >
                    {blok.headline && <h1 style={{ color: blok.text_color }}>{blok.headline}</h1>}
                    {blok.subheadline && <h2 style={{ color: blok.text_color }}>{blok.subheadline}</h2>}

                    {blok.button && blok.button[0]?.text && blok.button[0]?.link?.cached_url && (
                        <div className={HeaderStyles.button}>
                            <StoryblokButton blok={blok.button[0]} storyblokCommon={storyblokCommon} size="large" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header;
